var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4757 8.26793V6.79269H18.3643V4.92664H17.4757V3.59375H15.2542V4.92664H14.2768V6.79269H15.2542V8.25212C12.6773 8.75329 10.6708 11.0569 10.6708 13.8162C10.6708 16.9407 13.2202 19.4827 16.3446 19.4827C19.4692 19.4827 22.0001 16.9408 22.0001 13.8162C22.0001 11.0867 20.0527 8.80216 17.4757 8.26793ZM16.3521 17.2611C14.4525 17.2611 12.9071 15.7157 12.9071 13.8161C12.9071 11.9165 14.4525 10.3711 16.3521 10.3711C18.2517 10.3711 19.7972 11.9165 19.7972 13.8161C19.7971 15.7158 18.2517 17.2611 16.3521 17.2611Z",
    fill: "#4C4F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3368 8.1196C11.3368 4.99513 8.80223 2.45312 5.67767 2.45312C2.55311 2.45312 0 4.99513 0 8.1196C0 10.8803 2.01409 13.1849 4.59101 13.6844V16.1716L3.86378 15.5445L2.66676 16.9697L5.71419 19.5418L8.85404 16.9799L7.66004 15.5343L6.81258 16.2148V13.6668C9.38942 13.1313 11.3368 10.8477 11.3368 8.1196ZM2.23997 8.1196C2.23997 6.22005 3.78541 4.67461 5.68505 4.67461C7.58468 4.67461 9.13013 6.22005 9.13013 8.1196C9.13013 10.0192 7.58468 11.5647 5.68505 11.5647C3.78541 11.5647 2.23997 10.0192 2.23997 8.1196Z",
    fill: "#4C4F5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGender);
export default __webpack_public_path__ + "static/media/user-gender.39854cb1b547a03dea54d02017282040.svg";
export { ForwardRef as ReactComponent };